export default {
    device: {
        general: "General",
        details: "Detalles del Dispositivo",
        id: "ID",
        deviceId: "Identificación del Dispositivo",
        radioId: "Identificación de la Radio",
        meterId: "Identificación del Medidor",
        poleId: "Identificación del Poste",
        lastReadTime: 'Hora de la última lectura',
        lastReadTimeThresholdHrs: 'Horas de umbral 1 - 24',
        productType: "Tipo de Producto NA2W",
        sets: "Conjuntos",
        esm: "ESM",
        esmDevices: "Dispositivos ESM",
        firstHeard: "Escuchado por wrimera Vez",
        discovered: "Descubierta",
        lastReadMessage: "Último mensaje leído",
        stats: "Estadística",
        avgRIS: "Rendimiento de lectura promedio",
        RIS: "Rendimiento de lectura",
        rds: "Recopilación de lecturas de facturación - Tasa de éxito",
        dailyRIS: "Rendimiento de lectura",
        ris: {
            latest: "Recopilación de intervalos de lectura - Tasa de éxito",
        },
        dailyRISAndThroughput: "Rendimiento de lectura y Rendimiento Diario",
        avgThroughput: "Rendimiento medio",
        stales: "Pasados",
        readStales: "Leer Pasados",
        timeSinceLastRead: 'Tiempo desde la última lectura',
        staleFilters:{
            Day1: "1 Día",
            Days2: "2 Dias",
            Days3: "3 Dias",
            Days7: "7 Dias",
            Days14Plus: "14+ Dias"
        },
        isESM:{
            false: "Dispositivos no ESM",
            true: "Dispositivos ESM"
        },
        sampleRate: "Frecuencia de muestreo",
        expectedSamples: "Muestras esperadas por día",
        throughput: "Rendimiento",
        throughputError: "Error al recuperar datos de rendimiento del dispositivo",
        firmwareVersion: "Versión de firmware de metrología",
        esmInfo: {
            underflowFlag: 'Subdesbordamiento ESM',
            snapshotCount: 'Recuento de instantáneas de ESM',
            intervalCount: 'Recuento de intervalos de ESM',
            overflowFlag: 'Desbordamiento de ESM'
        },
        zFactor: "Z-Factor",
        zFactorValues: [
            "1",
            "2",
            "3",
            "4"
        ],
        allowMPT: "Permitir MPT",
    },
    productTypes: {
        0: "0 - NA2W Water",
        1: "1 - NAW2 Gas",
        2: "2 - NA2W Gas Shutoff Valve",
        3: "3 - NA2W MLC or SLC",
        4: "4 - NA2W Three Port Gas Corrector",
        5: "5 - NA2W Dual Port Gas",
        6: "6 - Arqiva Water (Low Power Support)",
        7: "7 - Arqiva Water (No Low Power Support)",
        8: "8 - Arqiva Liberty Gas",
        9 : "9 - Arqiva Water (under-pitlid, TC/3wire, Low Power)",
        10: "10 - NA2W Three Port (U90595 Rev. 5 hardware)",
        11: "11 - NA2W Dual Port Pulse Gas (U90595 Rev. 5 hardware)",
        12: "12 - Electronic Register (2012)",
        13: "13 - SLC Phase II Light Controller (U90952)",
        14: "14 - SLC Phase II Radio (U90951)",
        15: "15 - Wireless (TFR) ESAAP Electronic Register",
        16: "16 - ESAAP SmartPoint, TFR Support",
        17: "17 - Smart Gateway",
        18: "18 - SLC Phase III",
        19: "19 - Cathodic Protection Test Point",
        20: "20 - iPERL2",
        21: "21 - Wireless (TFR) ESAAP iPerl",
        22: "22 - Wireless (TFR) ESAAP PulseRF",
        23: "23 - Japan Demo",
        24: "24 - Australia Demo",
        25: "25 - Bullhorn FlexNet Radio Module",
        26: "26 - AutoGun Bluetooth",
        27: "27 - ESAAP MP SmartPoint",
        28: "28 - Japan Field Trial",
        29: "29 - Electronic Register Plus",
        30: "30 - PHIT2",
        31: "31 - SLC-SELC Radio",
        32: "32 - SLC-SELC Light Controller",
        33: "33 - Sonix V2 Radio EP1",
        34: "34 - Sonix V2 Meter Phase I",
        35: "35 - Utilty Pole Monitor",
        36: "36 - FlexNet iPERL S4 Radio EP1",
        37: "37 - AutoGun Bluetooth (Internal Bluetooth Firmware)",
        38: "38 - sim3l1xx 900MHz Development Board",
        39: "39 - Chile Field Trial",
        40: "40 - EFM32GG 900MHz Development Board",
        41: "41 - Japan Field Trail Gen 2",
        42: "42 - FlexNet iPERL S4 Radio",
        43: "43 - SonixV2 Radio Phase I",
        44: "44 - iPERL ASIC",
        45: "45 - Genesis ROW",
        46: "46 - Omni eRegister Plus",
        49: "49 - Genesis North America",
        50: "50 - Water Pulse",
        51: "51 - Omni Optical Adaptor",
        52: "52 - Wireless (TFR) ESAAP iPerl ULFN",
        53: "53 - SonixV2 Radio Phase II",
        54: "54 - SonixV2 Meter Phase II",
        55: "55 - CommandLink II",
        56: "56 - ESAAP Agnostic SmartPoint",
        57: "57 - NA2W Water 3i"
    }
}
